import type { IntegrationType } from "@v2/features/settings/shop/integrations/IntegrationForm";

import * as React from "react";

import { INTEGRATION_CONFIGS } from "@v2/features/settings/shop/integrations/config";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { routes } from "@v2/utils/router";
import { generatePath, useNavigate } from "react-router-dom";

type IntegrationCompactCardProps = {
  integrationType: IntegrationType;
  isExpired?: boolean;
};

const IntegrationCompactCard: React.FC<IntegrationCompactCardProps> = ({
  integrationType,
  isExpired = false,
}) => {
  const navigate = useNavigate();
  const projectId = useCurrentProjectId();
  const config = INTEGRATION_CONFIGS[integrationType];

  const goToDetail = () => {
    navigate(
      generatePath(routes.shops.integrations.detail, {
        projectId: projectId ?? "",
        integrationType,
      }),
    );
  };

  return (
    <button
      type="button"
      className="shrink-0 flex items-center gap-2.5 rounded-lg border-0.5 border-border pl-2 pr-4 py-2 cursor-pointer hover:bg-button-secondary-hover transition-colors"
      onClick={goToDetail}
    >
      <div className="relative shrink-0">
        <img
          src={config.image}
          alt={config.title}
          className="size-5 rounded-md object-contain"
        />
        {/* Status dot — semantic positive for active, sky for expired */}
        <div
          className={`absolute -bottom-0.5 -right-0.5 size-2 rounded-full ring-2 ring-white ${isExpired ? "bg-sky" : "bg-positive-default"}`}
        />
      </div>
      <span className="text-sm font-medium text-default whitespace-nowrap">
        {config.title}
      </span>
    </button>
  );
};

export default IntegrationCompactCard;
